<p>Sample rate is determined by the microphone selected and its settings.</p>
